import React from 'react';
import ProductItem from 'src/components/global/ProductItem';
import GCarousel from '../GCarousel';
import logoOnly from 'src/assets/images/logo_only.png';

const ExploreProducts = () => {
  return (
    <section style={{ backgroundColor: 'rgba(255, 215, 37, 0.02)' }}>
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="mb-5 position-relative">
              <h2>Explore Product</h2>
              <span className="title-shadow"></span>
            </div>
          </div>
        </div>
        <div className="row mt-5 mt-md-0">
          <div className="col">
            <GCarousel
              items={4}
              lgItems={3}
              mdItems={2}
              smItems={1}
              className="no-pb nav-style2"
              nav
              margin={30}
              dots={false}
              autoPlay
              loop
            >
              <div className="item">
                <ProductItem
                  name="Standard Edition"
                  link="/explore-product/standard"
                  img="/images/product/standard.png"
                  price={'0.028 BTC'}
                  unit="Current price"
                  favor="50% off"
                  author={{
                    name: '1 Exchange',
                    avatar: logoOnly,
                    link: '/resellers',
                  }}
                  btnText="Buy Now"
                  btnColor="success"
                />
              </div>
              <div className="item">
                <ProductItem
                  name="Pro Edition"
                  link="/explore-product/pro"
                  img="/images/product/pro.png"
                  price="0.05 BTC"
                  unit="Current price"
                  favor="50% off"
                  author={{
                    name: '3 Exchanges',
                    avatar: logoOnly,
                    link: '/resellers',
                  }}
                  btnText="Buy Now"
                  btnColor="success"
                />
              </div>
              <div className="item">
                <ProductItem
                  name="Ultimate Edition"
                  link="/explore-product/ultimate"
                  img="/images/product/ultimate.png"
                  price="0.08 BTC"
                  unit="Current price"
                  favor="50% off"
                  author={{
                    name: 'Unlimited Exchanges',
                    avatar: logoOnly,
                    link: 'resellers',
                  }}
                  btnText="Buy Now"
                  btnColor="success"
                />
              </div>
              <div className="item">
                <ProductItem
                  name="Market Maker"
                  link="/explore-product/mm"
                  img="/images/product/mm.png"
                  price="24k tokens"
                  unit="Current price"
                  favor="Closed"
                  author={{
                    name: 'Futures & Spot',
                    avatar: logoOnly,
                    link: '#',
                  }}
                  btnText="Closed Beta"
                  btnColor="danger"
                />
              </div>
              <div className="item">
                <ProductItem
                  name="Arbitrage"
                  link="/explore-product/br"
                  img="/images/product/br.png"
                  price="12k tokens"
                  unit="Current price"
                  favor="Closed"
                  author={{
                    name: 'Triangular Arbitrage',
                    avatar: logoOnly,
                    link: '#',
                  }}
                  btnText="Closed Beta"
                  btnColor="danger"
                />
              </div>
            </GCarousel>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExploreProducts;
